<template>
  <el-form label-width="100px" label-position="left">
    <div class="title-text">素材列表</div>
    <el-card>
      <PageMediaTable
        ref="pageMedia"
        :disabled="true"
        :brandIcon="brandIcon"
        :bgImage="bgImage"
        :mediaList="model.mediaVOList"
      />
    </el-card>
    <template v-if="model.supportMode === 2">
      <div class="title-text">打底素材</div>
      <el-card style="padding-bottom: 20px;margin-bottom: 20px">
        <el-col :span="10">
          <el-form-item label="物料ID">{{ model.backupMediaId }}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="物料名称">{{ model.backupMediaName }}</el-form-item>
        </el-col>
      </el-card>
      <div class="title-text">打底交互事件</div>
      <TargetEvent
        :partnerId="scheduleForm.partnerId"
        :keyEventList="model.backupKeyEventList"
        :autoEventList="model.backupAutoEventList"
        :voiceEventList="model.backupVoiceEventList"
        :disabled="true"
      />
    </template>
    <div class="title-text">监测代码</div>
    <TrackCodeDetail
      v-for="item in trackOptions"
      showType
      :key="item.key"
      :title="item.name"
      :trackList="model[`${item.key}`]"
    />
    <template v-if="model.mobileTrackList && model.mobileTrackList.length > 0">
      <div class="title-text">移动端监测</div>
      <TrackCodeDetail
        hideHeader
        :showType="false"
        :trackList="model.mobileTrackList"
      />
    </template>
    <el-row style="padding-top: 10px;">
      <el-col :span="10">
        <el-form-item label="结算监测类型">{{ settlementTypeObj[model.settlementType] }}</el-form-item>
      </el-col>
      <el-col :span="10">
        <el-form-item label="结算监测商">{{ model.settlementProvider || '-' }}</el-form-item>
      </el-col>
    </el-row>
    <div class="title-text">交互事件</div>
    <TargetEvent
      :partnerId="scheduleForm.partnerId"
      :keyEventList="model.keyEventList"
      :autoEventList="model.autoEventList"
      :voiceEventList="model.voiceEventList"
      :disabled="true"
    />
    <template v-if="model.tipsDetail">
      <div class="title-text">提示语</div>
      <el-card
        class="content-box"
        shadow="never"
        :body-style="{ padding: 0 }"
        :header="convertTempName(model.tipsTempId)"
      >
        <AdTipsDetail :tipsDetail="JSON.parse(model.tipsDetail)" />
      </el-card>
    </template>
    <div class="title-text">落地页监测代码</div>
    <TrackCodeDetail
      v-for="item in trackOptions"
      :key="`${item.key}Landing`"
      :title="item.name"
      :trackList="model[`${item.key}Landing`]"
    />
    <template v-if="landingTips && landingTips.content">
      <div class="title-text">落地页提示语</div>
      <el-card
        title="落地页提示"
        class="content-box"
      >
        <AdTipsDetail :show-text-style="false" :tips-detail="[landingTips]" />
      </el-card>
    </template>
  </el-form>
</template>

<script>
import TrackCodeDetail from './TrackCodeDetail.vue'
import PageMediaTable from './PageMediaTable.vue'
import {
  trackOptions,
  eventOptions,
  settlementTypeObj,
  genTargetEvent,
  genTracks,
  genTracksLanding
} from '../MaterialCreative.js'
import TargetEvent from '@/components/targetEvent/index.vue'
import AdTipsDetail from '@/components/media/AdTipsDetail.vue'

export default {
  components: {
    TargetEvent,
    TrackCodeDetail,
    PageMediaTable,
    AdTipsDetail,
  },
  props: {
    scheduleForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    creativeModel: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      targetEventTabActive: 'keyEventList',
      eventOptions,
      trackOptions,
      settlementTypeObj,
      spaceTempList: [],
      model: {
        tipsTempId: '',
        tipsDetail: '',
        settlementType: 0,
        settlementProvider: '',
        mediaList: [],
        backupMediaId: '',
        backupMediaName: '',
        landingTipsDetail: [],
        ...genTargetEvent(),
        ...genTracks(),
        ...genTracksLanding()
      },
      brandIcon: 0,
      bgImage: 0
    }
  },
  computed: {
    tipsDetailList() {
      return this.model.tipsDetail ? JSON.parse(this.model.tipsDetail) : []
    },
    landingTips() {
      const landingTipsDetail = this.model.landingTipsDetail.length ? this.model.landingTipsDetail[0] : ''
      return landingTipsDetail ? JSON.parse(landingTipsDetail) : {}
    }
  },
  watch: {
    creativeModel: {
      handler(val) {
        this.model = val
      }
    }
  },
  methods: {
    init() {
      if (this.scheduleForm.spaceId) {
        this.$service
          .getAdTempTips({ spaceId: this.scheduleForm.spaceId })
          .then((res) => {
            this.spaceTempList = res || []
          })
        this.getSpaceInfo()
      }
    },
    async getSpaceInfo() {
      const spaceModel = await this.$service.getSpaceModelById({ spaceId: this.scheduleForm.spaceId })
      this.brandIcon = spaceModel.brandIcon
      this.bgImage = spaceModel.bgImage
    },
    convertTempName(tipsTempId) {
      const spaceTemp = this.spaceTempList.find(item => item.tempId === tipsTempId)
      return spaceTemp ? spaceTemp.tempName : '自定义'
    },
    convertType(type) {
      let msg = ''
      if (type === 'txt') {
        msg = '文字'
      } else if (type === 'image') {
        msg = '图片'
      } else if (type === 'qrcode') {
        msg = '二维码'
      }
      return msg
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="stylus" scoped>
.el-form-item
  margin-bottom 0
</style>
